import { Collection, CollectionPrinter } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { FieldEditor } from "../../Utils/FieldEditor";
import { GalleryField } from "../../../Models/Description/Gallery/GalleryField";
import { GalleryItemEditor } from "./GalleryItemEditor";
import { PicsUploader } from "./PicsUploader";
import { GalleryItem } from "../../../Models/Description/Gallery/GalleryItem";
import { AddFieldBox } from "../../Admin/AddFieldBox";
import { Tab } from "../../../Models/Product/Tab";
import { PrimaryButton } from "../../Utils/PrimaryButton";


export class GalleryItemsEditor extends FieldEditor
{
    constructor(field: GalleryField, fields: Collection<Field>, tabs: Collection<Tab>)
    {
        super("Galeria", field, fields, tabs, [
            new CollectionPrinter(field.Images, x => new GalleryItemEditor(x, field.Images)),
            // new AddFieldBox({
            //     "➕ Obraz": () => field.Images.Add(new GalleryItem({})),
            //     "➕ Obrazy": () =>
            //         this.Append(
            //             new PicsUploader((images) =>
            //                 field.Images.Add(
            //                     ...images.map(x => new GalleryItem({ NormalizedUrl: x.Normalized, ThumbnailUrl: x.Thumbnail, MiniUrl: x.Mini }))))
            //         ),
            // }),
            new PrimaryButton("➕ Dodaj zdjęcia")
                .OnClick(() =>
                    this.Append(
                        new PicsUploader((images) =>
                            field.Images.Add(
                                ...images.map(x => new GalleryItem({ NormalizedUrl: x.Normalized, ThumbnailUrl: x.Thumbnail, MiniUrl: x.Mini }))))
                    )
                )
        ]);
    }
}
